exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".compare-modal-wrapper{display:flex;align-items:center;justify-content:center;position:fixed;top:0;height:100%;width:100%;background-color:rgba(68,59,50,.9);cursor:pointer;z-index:9997;left:0}.compare-modal-wrapper--closeless{cursor:default}.compare-modal-close{position:absolute;width:18px;height:18px;top:1em;right:2em;left:auto;cursor:pointer;z-index:9999}.compare-modal-close svg path{fill:#434343}.compare-modal-body{cursor:default;display:flex;justify-content:center;position:relative}body[dir=rtl] .compare-modal-wrapper {\n  right: 0;\n}body[dir=rtl] \n.compare-modal-close {\n  left: 2em;\n  right: auto;\n}\n", ""]);

// exports
